import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import {
	wrapperStyle,
	innerWrapperStyle,
	donateButtonStyle,
} from './styles';

export const GreyBar = ({ links, topMargin }) => (
	<div data-component="GreyBar" className={wrapperStyle(topMargin)}>
		<nav className={innerWrapperStyle}>
			<Link to="/get-involved/make-a-donation">
				Want to help our cause? <button className={donateButtonStyle}>Donate</button>
			</Link>
		</nav>
	</div>
);

GreyBar.propTypes = {
	topMargin: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/shared/greyBar/component.js